/*
 *
 * DisableVasPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 19-May-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DisableVasPopup from './DisableVasPopup'
import * as actionLayer from 'Route/TerminalsManagement/modules/TerminalsManagementActions'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  isLoading: state.loading?.local_manageVas || false,
  featureName: state?.TerminalsManagement?.selectedVas?.feature?.name || ''
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DisableVasPopup)
